import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import GroupApprovers from "../FieldTags/GroupApprovers";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ScopeOfWorkRequired = ({ scopeOfWorkRequired, sampleDisposal, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, ROLES.ELEVATED);

    return (
        <div id="scopeOfWorkRequired" className="planField">
            <GroupApprovers />
            <FormControl>
                <FormLabel className="planRadioTitle" required={required.includes("scopeOfWorkRequired")}>
                    {xplanLabels.scopeOfWorkRequired}
                </FormLabel>
                <RadioGroup
                    name="scopeOfWorkRequired"
                    label={xplanLabels.scopeOfWorkRequired}
                    value={scopeOfWorkRequired}
                    onChange={(e) => handleChange("scopeOfWorkRequired", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value={sampleDisposal === "No" ? "TS Sample Request" : "No"}
                        control={<Radio disabled={!canEdit} />}
                        label={sampleDisposal === "No" ? "TS Sample Request" : "No"}
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"scopeOfWorkRequired"} /> }
        </div>
    );
};

export default ScopeOfWorkRequired;